var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "grid", "margin-top": "2rem" } },
    [
      _c(
        "button",
        {
          staticClass: "btn-outline btn-dark",
          on: {
            click: function ($event) {
              return _vm.openModal()
            },
          },
        },
        [
          _c("i", { staticClass: "fa-light fa-arrow-up-from-bracket" }),
          _vm._v("Import payments"),
        ]
      ),
      _vm._v(" "),
      _vm.isAlertOpen
        ? _c("alert-modal", [
            _c("span", [
              _c("i", { staticClass: "fa-solid fa-circle-check" }),
              _vm._v(
                "Bulk allocation complete: : " +
                  _vm._s(this.countCreated) +
                  " new, " +
                  _vm._s(this.countExisting) +
                  " existing"
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isModalOpen
        ? _c("div", { staticClass: "modal-container" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("h1", [
                _vm._v("Bulk Import Payments"),
                _c("i", {
                  staticClass: "fa-regular fa-xmark",
                  on: {
                    click: function ($event) {
                      return _vm.closeModal()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticStyle: { "font-weight": "normal", color: "#717182" } },
                [
                  _vm._v(
                    "Download the CSV template, fill it with payment data, and upload to add payments to the queue."
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "information-container" }, [
                _c("i", { staticClass: "fa-regular fa-file-lines" }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "download-btn btn btn-outline",
                    on: { click: _vm.exportCSVTemplate },
                  },
                  [
                    _c("i", {
                      staticClass: "fa-regular fa-arrow-down-to-bracket",
                    }),
                    _vm._v("Download Template"),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.payments.length == 0
                ? _c(
                    "div",
                    {
                      staticClass: "drop-zone",
                      class: { hover: _vm.isDragOver },
                      on: {
                        dragover: function ($event) {
                          $event.preventDefault()
                        },
                        dragenter: function ($event) {
                          $event.preventDefault()
                          _vm.isDragOver = true
                        },
                        dragleave: function ($event) {
                          $event.preventDefault()
                          _vm.isDragOver = false
                        },
                        drop: function ($event) {
                          $event.preventDefault()
                          return _vm.onDrop.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa-regular fa-arrow-up-from-bracket",
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "Drag and drop your CSV file here, or click to browse"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("CSV file with clientNumber column")]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn-outline btn-dark",
                            attrs: { type: "file" },
                            on: { click: _vm.importCSVFile },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "fa-regular fa-arrow-up-from-bracket",
                            }),
                            _vm._v(" Select CSV file"),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _c(
                    "div",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "align-items": "center",
                            "font-size": "1.25rem",
                            "font-weight": "bold",
                            color: "black",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "Preview (" +
                                _vm._s(_vm.payments.length) +
                                " payments)"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { display: "flex", gap: "1rem" } },
                            [
                              _c(
                                "span",
                                {
                                  class: {
                                    "btn-outline button-primary":
                                      _vm.payments.filter(function (item) {
                                        return item.status == 1
                                      }).length > 0,
                                    "btn-outline-light btn":
                                      _vm.payments.filter(function (item) {
                                        return item.status == 1
                                      }).length == 0,
                                  },
                                  style: {
                                    cursor: "default",
                                    "pointer-events": "none",
                                    "background-color":
                                      _vm.payments.filter(function (item) {
                                        return item.status == 1
                                      }).length > 0
                                        ? "#f0fdf4"
                                        : "white",
                                    color:
                                      _vm.payments.filter(function (item) {
                                        return item.status == 1
                                      }).length > 0
                                        ? "#008236"
                                        : "",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.payments.filter(function (item) {
                                        return item.status == 1
                                      }).length
                                    ) + " valid"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.payments.filter(function (item) {
                                return item.status == 0
                              }).length > 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "btn-outline button-primary",
                                      staticStyle: {
                                        cursor: "default",
                                        "pointer-events": "none",
                                        "background-color": "#fef2f2",
                                        color: "#c10007",
                                        "border-color": "#ffc9c9 !important",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.payments.filter(function (item) {
                                            return item.status == 0
                                          }).length
                                        ) + " invalid"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn-outline-light btn",
                                  on: {
                                    click: function ($event) {
                                      _vm.payments = []
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-xmark",
                                  }),
                                  _vm._v(" Clear"),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-table", {
                        staticClass: "table-header-border",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: {
                          responsive: "",
                          items: _vm.payments,
                          fields: _vm.fields,
                          "primary-key": "id",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "head(index)",
                              fn: function () {
                                return [_c("span", [_vm._v("#")])]
                              },
                              proxy: true,
                            },
                            {
                              key: "cell(status)",
                              fn: function (data) {
                                return [
                                  data.item.status == 1
                                    ? _c("i", {
                                        staticClass:
                                          "fa-regular fa-circle-check",
                                        staticStyle: { color: "#00a63e" },
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "fa-regular fa-circle-exclamation",
                                        staticStyle: { color: "#d4183d" },
                                      }),
                                ]
                              },
                            },
                            {
                              key: "cell(VIBAN)",
                              fn: function (data) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(data.item.VIBAN) +
                                        "\n          "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(amount)",
                              fn: function (data) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      "\n            €" +
                                        _vm._s(data.item.amount) +
                                        "\n          "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(date)",
                              fn: function (data) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(data.item.date) +
                                        "\n          "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(reference)",
                              fn: function (data) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(data.item.reference) +
                                        "\n          "
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          26041347
                        ),
                      }),
                      _vm._v(" "),
                      _vm.payments.some(function (item) {
                        return item.status == 1
                      })
                        ? _c(
                            "div",
                            {
                              staticClass: "card p-6",
                              staticStyle: { color: "#d4183d" },
                            },
                            [
                              _vm._m(1),
                              _vm._v(" "),
                              _vm._l(
                                _vm.payments.filter(function (p) {
                                  return p.status === 0
                                }),
                                function (item, index) {
                                  return _c("span", { key: index }, [
                                    _vm._v(
                                      "\n            Row " +
                                        _vm._s(index + 2) +
                                        ": VIBAN not in pool – payment will be unidentified\n          "
                                    ),
                                  ])
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn-outline-light btn",
                              on: { click: _vm.closeModal },
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          _vm.payments.filter(function (item) {
                            return item.status == 1
                          }).length > 0
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn-outline btn-dark",
                                  on: {
                                    click: function ($event) {
                                      _vm.addToQueue(
                                        _vm.payments.filter(function (item) {
                                          return item.status == 1
                                        })
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "Add " +
                                      _vm._s(
                                        _vm.payments.filter(function (item) {
                                          return item.status == 1
                                        }).length
                                      ) +
                                      " Valid Payments to Queue"
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("CSV Template")]),
      _vm._v(" "),
      _c("span", [
        _vm._v("Download template with sample data and required columns"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticStyle: { display: "flex", gap: "1rem", "font-weight": "bold" } },
      [
        _c("i", { staticClass: "fa-regular fa-circle-exclamation" }),
        _vm._v(" Validation Errors Found:"),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }